import { Clickable } from '@shared/Frontend/components/clickable'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { translate } from '@shared/Frontend/utils/translate'
import * as React from 'react'
import { DownloadBlock } from '../../blocks.state'

export const ArchivedDownloadBlockLayout = (props: {
  id: string
  items: DownloadBlock['items']
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}) => {
  const { id, items, isOpen, onOpen, onClose } = props
  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section
      id={id}
      ref={ref}
      className={cn('block block--download block--archive ls-block-spacing', inView && 'inview')}
    >
      <div className="block__inner ls-container">
        <div className="block__layout ls-columns">
          {isOpen ? (
            <>
              <header className="block__header ls-columns__header">
                <div className="block__header-inner ls-reversed-column">
                  <h2 className="block__title title--l">{translate('Common:Archive:title')}</h2>
                </div>
              </header>

              <div className="block__content ls-columns__main">
                {items && items.length > 0 && <ListLayout listClassName="block__list" items={items} />}
                <div className="block__footer">
                  <Clickable
                    elementKind="button"
                    styleKind="button"
                    className="outline-button"
                    icon="chevron-up"
                    title={translate('Common:Archive:button_hide')}
                    onClick={onClose}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="block__footer ls-columns__main">
              <Clickable
                elementKind="button"
                styleKind="button"
                className="outline-button"
                icon="chevron-down"
                title={translate('Common:Archive:button_show')}
                onClick={onOpen}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export const ListLayout = (props: { items: DownloadBlock['items']; listClassName?: string; nested?: boolean }) => {
  if (props.items && props.items.length > 0) <></>
  return (
    <ul className={`blocklist ${props.listClassName || ''}`}>
      {props.items.map((item, index) => {
        if (!item.url) return <></>
        return <ItemLayout key={`download-${index}`} {...item} nested={props.nested} />
      })}
    </ul>
  )
}

const ItemLayout = (props: { title: string; text?: string; url: string; nested?: boolean }): JSX.Element => {
  const { title, url, text, nested } = props
  return (
    <li className="blocklist__item">
      <a
        download={true}
        target="_blank"
        rel="noopener noreferrer"
        href={url}
        className={nested ? '' : 'blocklist__link'}
        onClick={() => pushDatalayer({ category: 'Downloads', action: title })}
      >
        <div className="blocklist__text">
          {title && <p className="blocklist__title title--s">{title}</p>}
          {text && <p className="blocklist__subtitle">{text}</p>}
        </div>
      </a>
    </li>
  )
}
